import { PinnedContext } from "@shaarp/common";

export const MAX_PINNED_PROMPTS: Record<PinnedContext, number> = {
  chat: 3,
  company: 8,
};
